import useSWR from 'swr';
import urlResolver from 'admin/utils/URLResolver';
import { getter } from 'core/utils/request';

const useSchools = () => {
  const { data: schools, error: schoolsError } = useSWR(
    urlResolver.reverse('api:get-all-schools'),
    getter
  );

  return {
    schools,
    schoolsError,
    schoolsLoading: !schools && !schoolsError,
  };
};

export default useSchools;
